import {useState} from 'react';

import {Box, Tooltip, styled, tooltipClasses, TooltipProps} from '@mui/material';
import {useTranslation} from 'react-i18next';

import MapMarker from 'assets/images/mapMarker.svg';

const mapMarkerImage = MapMarker;

interface IMapMarkerIcon {
  tooltipVisible?: boolean;
}
export const MapMarkerIcon = ({tooltipVisible}: IMapMarkerIcon) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const {t} = useTranslation();
  return (
    <Box
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <CustomTooltip
        title={t('label.orderLocationTooltip')}
        arrow
        placement="top"
        open={tooltipVisible}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [0, -14]
                }
              }
            ]
          }
        }}
      >
        <Box>
          <img
            src={mapMarkerImage}
            alt="mapmarker-icon"
            onLoad={() => setImageLoaded(true)}
            style={{visibility: imageLoaded ? 'visible' : 'hidden'}}
          />
        </Box>
      </CustomTooltip>
    </Box>
  );
};

export default MapMarkerIcon;

const CustomTooltip = styled(({className, ...props}: TooltipProps) => (
  <Tooltip {...props} classes={{popper: className}} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: 'crimson',
    color: 'white',
    fontWeight: 'bold',
    fontSize: '14px',
    padding: '10px 15px',
    borderRadius: '8px',
    border: '2px solid white'
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'crimson'
  }
}));
